import {
  validateEmail,
  validateEmailsMatch,
  validateDateOfBirth,
  validateSurname,
  validatePassword,
  validateCode,
  validatePasswordsMatch,
  validateIsRequired,
  validatePostcode,
  validatePolicy
} from "@simplyhealth/iam_client_lib";


export type ValidatorFunction = (value: string) => string[];
export type CrossFieldValidatorFunction = (value: string, secondValue: string) => string[];

export function createRequiredValidator(fieldName: string): ValidatorFunction {
  return (value: string) => validateIsRequired(fieldName, value);
}

export function createPostcodeValidator(fieldName: string): ValidatorFunction {
  return (value: string) => validatePostcode(fieldName, value);
}

export function createValidatePolicy(fieldName: string): ValidatorFunction {
  return (value: string) => validatePolicy(fieldName, value);
}

export function createEmailValidator(): ValidatorFunction {
  return validateEmail;
}

export function createCrossFieldEmailValidator(): CrossFieldValidatorFunction {
  return validateEmailsMatch;
}

export function createCrossFieldPasswordValidator(): CrossFieldValidatorFunction {
  return validatePasswordsMatch;
}

export function createDateOfBirthValidator(): ValidatorFunction {
  return validateDateOfBirth;
}

export function createSurnameValidator(): ValidatorFunction {
  return validateSurname;
}

export function createPasswordValidator(): ValidatorFunction {
  return validatePassword;
}

export function createCodeValidator(): ValidatorFunction {
  return validateCode;
}

export function createLengthCheckValidtor(minLength: number): ValidatorFunction {
  return (value: string): string[] => {
    const messages = new Array<string>();
    if (value.length < minLength) {
      messages.push("value is too short");
    }
    if (value.startsWith("a")) {
      messages.push("value starts with a");
    }
    return messages;
  };
}
